<template>
    <div class="bg-white rounded shadow">
        <header class="flex items-center h-16 px-4 bg-white border-b rounded-t sm:px-6">
            <h3 class="flex-grow text-base font-normal">Tenants</h3>

            <div class="flex flex-none">
                <div class="mr-3">
                    <chats-store-button :personas="pluckTenants(data)">
                        Message Tenants
                    </chats-store-button>
                </div>

                <router-link
                    :to="newTo"
                    class="btn btn-sm btn-with-icon"
                >
                    <div class="flex items-center justify-center">
                        <base-svg
                            name="icon-add-circle"
                            class="w-6 h-6 md:mr-2"
                        />
                        <div class="hidden md:block">New Tenant</div>
                    </div>
                </router-link>
            </div>
        </header>

        <div
            v-if="meta.total === 0"
            class="p-3 italic text-center text-grey bg-grey-bg"
        >
            There's nothing here!
        </div>

        <with-dimensions
            v-else
            v-slot="{
                width
            }"
        >
            <table-ish>
                <table-ish-row
                    v-for="residency in data"
                    :key="residency.uuid"
            >
                    <table-ish-cell-router-link
                        :to="{
                            name: $router.fix('dashboard.*.occupants.show'),
                            params: {
                                occupant: residency.occupant.uuid
                            }
                        }"
                    >
                        <truncate-hack>
                            {{ residency.occupant.name }}
                        </truncate-hack>

                        <template
                            v-if="width <= 500"
                            slot="secondary"
                        >
                            <span
                                :class="punctualStateCss(residency.state)"
                                class="px-2 text-xs font-semibold leading-none rounded-full"
                            >
                                {{ $t(`residency.state.${residency.state}`) }}
                            </span>
                        </template>
                    </table-ish-cell-router-link>

                    <table-ish-cell
                        v-if="width > 500"
                        :shrink="true"
                        class="text-right"
                    >
                        <span
                            :class="punctualStateCss(residency.state)"
                            class="px-3 py-1 text-sm font-semibold rounded-full"
                        >
                            {{ $t(`residency.state.${residency.state}`) }}
                        </span>
                    </table-ish-cell>

                    <table-ish-cell
                        :shrink="true"
                        class="text-right"
                    >
                        <edit-dropdown
                            :residency="residency"
                            @success="onSuccess"
                        />
                    </table-ish-cell>
                </table-ish-row>
            </table-ish>
        </with-dimensions>

        <div
            v-if="meta.last_page > meta.page"
            class="px-4 py-2 text-sm font-semibold bg-grey-bg text-grey-darker sm:px-6"
        >
            <base-more
                :to="moreTo"
                :count="meta.count"
                :total="meta.total"
            />
        </div>
    </div>
</template>

<script>
    import _ from 'lodash'
    import StateCssMixin from '../../../../../mixins/state-css'
    import ChatsStoreButton from '../../../../../components/chats-store-button'
    import EditDropdown from './residencies-card/edit-dropdown'

    export default {
        mixins: [
            StateCssMixin
        ],
        components: {
            ChatsStoreButton,
            EditDropdown
        },
        props: {
            data: {
                type: Array,
                required: true
            },
            meta: {
                type: Object,
                required: true
            },
            newTo: {
                type: Object,
                default () {
                    return {
                        name: this.$router.fix('dashboard.*.residencies.create')
                    }
                }
            },
            moreTo: {
                type: Object,
                default () {
                    return {
                        name: this.$router.fix('dashboard.*.tenants.index')
                    }
                }
            }
        },
        methods: {
            onSuccess () {
                this.$emit('success')
            },
            pluckTenants (residency) {
                return _.chain(residency)
                    .map('occupant.tenant')
                    .filter()
                    .value()
            }
        }
    }
</script>
